module.exports = __webpack_public_path__ + "img/sch4-gift-title.b64ace8a.png";